// ABOUTME: Input/output validation schemas for TechLog → Rusada trip updates transformation.
import {
  ZRusadaTechLogInput,
  ZRusadaRegistrationResponse,
  ZRusadaTechLogCategoriesResponse,
  ZRusadaFlightTypesResponse,
  ZRusadaRegistrationLifeCodesResponse,
} from '../../../../activities/api/rusada/rusada.zod';
import { ZTechlogAircraftWithType } from '../../../../types/techLog/aircraft.zod';
import { ZTechLogTripUpdate } from '../../../../types/techLog/trip.zod';
import { z } from 'zod';

export const ZTechLogToRusadaTripUpdateInput = z.object({
  techlog: z.object({
    tripUpdate: ZTechLogTripUpdate,
    aircraft: ZTechlogAircraftWithType.optional(),
  }),
  rusada: z.object({
    registration: ZRusadaRegistrationResponse,
    // Deviation: single value derived from place lookup
    defaultPlaceId: z.number().int().positive(),
    techLogCategories: ZRusadaTechLogCategoriesResponse,
    flightTypes: ZRusadaFlightTypesResponse,
    registrationLifeCodes: ZRusadaRegistrationLifeCodesResponse.optional(),
  }),
});

export const ZTechLogToRusadaTripUpdateOutput = ZRusadaTechLogInput;

// Type exports - inferred from Zod schemas (single source of truth)
export type TechLogToRusadaTripUpdateInput = z.infer<
  typeof ZTechLogToRusadaTripUpdateInput
>;
export type TechLogToRusadaTripUpdateOutput = z.infer<
  typeof ZTechLogToRusadaTripUpdateOutput
>;
